/**
 * @file This file contains the configuration for Unicode skin tone modifiers.
 * @module skinToneConfig
 */

/**
 * An array of Unicode characters used to modify the skin tone of emojis.
 * @type {string[]}
 */
export const skinTones = [
    '🏻', // light skin tone
    '🏼', // medium-light skin tone
    '🏽', // medium skin tone
    '🏾', // medium-dark skin tone
    '🏿'  // dark skin tone
];
